import React from 'react';

// import { DataGrid } from '@mui/x-data-grid';
import {
  Container, Box, Typography, Paper, Button,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
} from '../mui';
import * as COL from '../../globals/ColConstants';
import './Grid.css';
import { HATCH, SEDAN } from '../../globals/Constants';

function ComparisonGrid({ cars, onClose, onRemoveCar }) {
  if (!cars) {
    return null;
  }

  const cols = [{ id: 'id', label: '', minWidth: 100 }];
  const carIds = ['id'];
  for (let i = 0; i < cars.length; i += 1) {
    const car = cars[i];
    cols.push({
      id: car.Id,
      minWidth: 150,
      label: `${car[COL.make]} ${car[COL.model]} ${car[COL.variant]}`,
      lastModified: car['Last Modified'],
    });
    carIds.push(car.Id);
  }

  const rows = [];

  const featuresToProcess = [COL.price, COL.bodyType, COL.releaseDate,
    COL.engineCapacity, COL.chargingSpeed, COL.acChargingSpeed, COL.v2l, COL.v2v,
    COL.batteryTechnology, COL.mileage, COL.power, COL.torque,
    COL.length, COL.width, COL.height, COL.wheelbase,
    COL.groundClearance, COL.turningRadius, COL.bootSpace,
    COL.tyres,
    COL.projectorHeadLamps, COL.automaticHeadlightControl,
    COL.fogLamps, COL.rainSensingWipers, COL.alloyWheels,

    COL.powerWindows, COL.driverSeatAdjust, COL.electFoldableMirrors,
    COL.electAdjustableMirrors, COL.autoDimmingIrvm, COL.tiltSteeringAdjust,
    COL.frontArmrest, COL.rearArmrest, COL.sunRoof,
    COL.rearAcVents, COL.trunkLight,

    COL.speakers, COL.androidPlay, COL.headsUpDisplay,
    COL.powerWindowsOneTouch, COL.rearSunshade, COL.followMeHomeLights,
    COL.wirelessCharging, COL.cooledGloveBox, COL.climateControl,
    COL.pushStart, COL.remoteKeylessEntry, COL.cruiseControl,
    COL.ventilatedFrontSeats, COL.steeringMountedControl,

    COL.rearSensors, COL.frontSensors,
    COL.sideCurtainAirbags, COL.frontSideAirbags, COL.dualHorn,
    COL.camera360, COL.laneCamera, COL.adas,
  ];
  for (let m = 0; m < featuresToProcess.length; m += 1) {
    const feature = featuresToProcess[m];
    let featureUnit = '';
    let featureLabel = feature;

    switch (feature) {
      case COL.price: featureUnit = 'lakhs'; break;
      case COL.engineCapacity:
        featureLabel = 'Battery Capacity';
        featureUnit = 'kWh';
        break;
      case COL.chargingSpeed:
        featureLabel = 'DC Charging Speed';
        featureUnit = 'kW';
        break;
      case COL.v2l:
        featureLabel = 'Vehicle-to-Load (V2L)';
        break;
      case COL.v2v:
        featureLabel = 'Vehicle-to-Vehicle (V2V)';
        break;
      case COL.acChargingSpeed:
        featureLabel = 'AC Charging Speed';
        featureUnit = 'kW';
        break;
      case COL.batteryTechnology:
        featureLabel = 'Battery Technology';
        break;
      case COL.mileage:
        featureLabel = 'Range';
        featureUnit = 'km';
        break;
      case COL.power: featureUnit = 'PS'; break;
      case COL.torque: featureUnit = 'NM@rpm'; break;
      case COL.length:
      case COL.width:
      case COL.height:
      case COL.wheelbase: featureUnit = 'mm'; break;
      case COL.groundClearance: featureUnit = 'mm'; break;
      case COL.turningRadius: featureUnit = 'm'; break;
      case COL.bootSpace: featureUnit = 'L'; break;

      default: break;
    }
    const featureSet = { id: `${featureLabel} ${featureUnit ? `(${featureUnit})` : ''}` };
    for (let n = 0; n < cars.length; n += 1) {
      const thisCar = cars[n];
      let displayValue = thisCar[feature];
      switch (feature) {
        case COL.bodyType: if (displayValue === HATCH) { displayValue = 'Hatch'; } else if (displayValue === SEDAN) { displayValue = 'Sedan'; }
          break;
        case COL.powerWindows: if (displayValue === 'F') { displayValue = 'Front only'; } else if (displayValue === 'FR') { displayValue = 'Both'; }
          break;
        default: break;
      }
      featureSet[thisCar.Id] = displayValue;
    }
    rows.push(featureSet);
  }

  return (
    <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
      <Button
        variant="contained"
        onClick={() => onClose()}
        sx={{
          position: 'absolute',
          top: 8,
          left: 8,
          zIndex: 999,
          minWidth: 'auto',
          px: 1.5,
        }}
      >
        X
      </Button>
      <TableContainer component={Paper} sx={{ width: '100%', height: '100%', overflow: 'auto' }}>
        <Table stickyHeader aria-label="sticky table" size="small">
          <TableHead>
            <TableRow>
              {cols.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  className={`${column.id === 'id' ? 'cc-stickyColHeader' : 'cc-nonSticky'}`}
                  style={{ minWidth: column.minWidth }}
                >
                  <div>
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                      <Box sx={{ flex: 1, textAlign: column.id === 'id' ? 'right' : 'left' }}>
                        {column.id === 'id' ? 'Data generated by AI' : column.label}
                      </Box>
                      {column.id !== 'id' && onRemoveCar && (
                        <Button
                          size="small"
                          onClick={() => onRemoveCar(column.id)}
                          sx={{
                            minWidth: 'auto',
                            padding: '2px 4px',
                            color: 'text.secondary',
                            fontSize: '0.75rem',
                            ml: 0.5,
                          }}
                        >
                          ×
                        </Button>
                      )}
                    </Box>
                    {column.lastModified && (
                      <Typography variant="caption" display="block" sx={{ color: 'text.secondary', fontSize: '0.7rem', mt: 0.5 }}>
                        Updated on
                        {' '}
                        {column.lastModified}
                      </Typography>
                    )}
                  </div>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .map((row) => (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                  {cols.map((column) => {
                    const value = row[column.id];
                    return (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        className={`${column.id === 'id' ? 'cc-stickyCol' : 'cc-nonSticky'}`}
                      >
                        {column.format && typeof value === 'number'
                          ? column.format(value)
                          : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default ComparisonGrid;
